export const PETS_SUBMIT = "booking/PETS_SUBMIT"
export const PETS_SUBMIT_FAILURE = "booking/PETS_SUBMIT_FAILURE"

export default PETS_SUBMIT
